import { Controller } from 'react-hook-form'

export default ({
  name, 
  control, 
  label, 
  defaultValue = false, 
  validator = {},
  disabled = false
}) => (
  <Controller
    name={name}
    control={control}
    defaultValue={defaultValue}
    render={({ field }) => (
      <>
        <label className={`label cursor-pointer ${validator.hasError && "validator"}`}
          {...(validator.hasError && validator.hasError(name) ? {'aria-invalid': true} : {})}
        >
          <input 
            type="checkbox" 
            checked={field.value === null ? defaultValue : !!field.value }
            onChange={(e) => field.onChange(e.target.checked)}
            className="checkbox" 
            disabled={disabled}
          />
          <span className="ml-1">{label}</span>
        </label>
        {validator.getErrorMessage && (
          <div className="validator-hint hidden mt-0 empty:py-[0.6rem]">
            {validator.getErrorMessage(name)}
          </div>
        )}
      </>
    )}
  />
)